var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"smart-icon",staticStyle:{"vertial-align":"middle"},style:(_vm.iconSizeStyle),attrs:{"viewBox":_vm.viewBox,"fill":"currentColor"},on:{"click":function (event) { return _vm.$emit('click', event); }}})}
var staticRenderFns = []

export { render, staticRenderFns }